<script setup lang="ts">
import { useFormValidation } from '../../../../composables/useFormValidation'
import { required } from '../../../../utils/validation'
import TextInput from '../../../../components/ui/form/TextInput.vue'
import { ref, onMounted } from 'vue'

import ModalFormTemplate from '../../../../components/ui/Templates/ModalFormTemplate.vue'
import SearchSelect from '../../../../components/ui/form/SearchSelect.vue'
import NumberInput from '../../../../components/ui/form/NumberInput.vue'

const props = defineProps<{
  data?: any | null  
}>()

const emit = defineEmits<{
  (e: 'save', data: any): void
  (e: 'close'): void
}>()

const title = 'Edit Price Label Field'

const { fields, formData, setFieldRules, validateForm, setFormData } = useFormValidation({
    name: props.data?.name || '',
    caption: props.data?.caption || '',
    width:  props.data?.width || 0,
    height:  props.data?.height || 0,
    y:   props.data?.y || 0,
    x:   props.data?.x || 0,
    align:  props.data?.align || 'C',
    font_name:   props.data?.font_name || '',
    font_size:   props.data?.font_size || 8,
    font_style:   props.data?.font_style || '',
    bar_type:   props.data?.bar_type || '',
    default:   props.data?.default || '',
  });

setFieldRules("name", [required("Outlet is required")]);

const handleSubmit = async () => {
  if (validateForm()) {
    emit('save', formData.value)
  }
}

const isReadOnly = ref(true);
onMounted(() => {
  isReadOnly.value = false
  setFormData(props.data)
})

</script>
<template>
  <ModalFormTemplate :data="data" :mode="'create'" :title="title" :endPoint="''" :perm="[]"
    :tabList="[]" :formData="formData" @save="handleSubmit" :ignore-permission="true"
    @close="$emit('close')" width="40rem">
    <template #form>
      <div class="grid md:grid-cols-4 gap-6">
        
        <TextInput
          v-model="fields.caption.value"
          label="Caption"
          class="col-span-2"
          :readonly="true"
          :error="fields.caption.touched ? fields.caption.error : null"
          @blur="fields.caption.touched = true"
        />

        <SearchSelect
          v-model="fields.bar_type.value"
          label="Barcode Type"
          class="col-span-2"
          :options="[
            { id: '128', name: 'Code 128' },
            { id: '128A', name: 'Code 128A' },
          ]"
          :remote="false"
          :readonly="isReadOnly"
          :error="
            fields.bar_type.touched ? fields.bar_type.error : null
          "
          @blur="fields.bar_type.touched = true"
        />

        <NumberInput
          v-model="fields.width.value"
          label="Width"
          :readonly="isReadOnly"
          :error="fields.width.touched ? fields.width.error : null"
          @blur="fields.width.touched = true"
        />

        <NumberInput
          v-model="fields.height.value"
          label="Height"
          :readonly="isReadOnly"
          :error="fields.height.touched ? fields.height.error : null"
          @blur="fields.height.touched = true"
        />

        <NumberInput
          v-model="fields.y.value"
          label="Position Y"
          :readonly="isReadOnly"
          :error="fields.y.touched ? fields.y.error : null"
          @blur="fields.y.touched = true"
        />

        <NumberInput
          v-model="fields.x.value"
          label="Position X"
          :readonly="isReadOnly"
          :error="fields.x.touched ? fields.x.error : null"
          @blur="fields.x.touched = true"
        />

        <SearchSelect
          v-model="fields.align.value"
          label="Alignment"
          :options="[
            { id: 'C', name: 'Center' },
            { id: 'L', name: 'Left' },
            { id: 'R', name: 'Right' }
          ]"
          :remote="false"
          :readonly="isReadOnly"
          :error="
            fields.align.touched ? fields.align.error : null
          "
          @blur="fields.align.touched = true"
        />

        <SearchSelect
          v-model="fields.font_name.value"
          label="Font Name"
          :options="[
            { id: 'helvetica', name: 'helvetica' },
          ]"
          :remote="false"
          :readonly="isReadOnly"
          :error="
            fields.font_name.touched ? fields.font_name.error : null
          "
          @blur="fields.font_name.touched = true"
        />

        <NumberInput
          v-model="fields.font_size.value"
          label="Font Size"
          :readonly="isReadOnly"
          :error="fields.font_size.touched ? fields.font_size.error : null"
          @blur="fields.font_size.touched = true"
        />

        <SearchSelect
          v-model="fields.font_style.value"
          label="Font Style"
          :options="[
            { id: 'B', name: 'Bold' },
          ]"
          :remote="false"
          :readonly="isReadOnly"
          :error="
            fields.font_style.touched ? fields.font_style.error : null
          "
          @blur="fields.font_style.touched = true"
        />        
        
        <TextInput
          v-model="fields.default.value"
            class="col-span-2"
          label="Override Text"
          :readonly="isReadOnly"
          :error="fields.default.touched ? fields.default.error : null"
          @blur="fields.default.touched = true"
        />
        
      </div>
    </template>
  </ModalFormTemplate>
</template>